import _extends from "@babel/runtime/helpers/extends";
import { jsx as ___EmotionJSX } from "@emotion/core";
import React from 'react';

var _ref =
/*#__PURE__*/
___EmotionJSX("path", {
  d: "M17.11 67.038c8.709 2.676 21.322.893 23.259-5.132C42.91 54 36.07 49.501 26.62 46.708c-9.45-2.792-18.883-.37-20.807 5.192C3.377 57.053 8.4 64.362 17.11 67.038z",
  fill: "#73C4FF"
});

var _ref2 =
/*#__PURE__*/
___EmotionJSX("rect", {
  x: .293,
  y: 14.109,
  width: 52,
  height: 20,
  rx: 10,
  transform: "rotate(-15.082 .293 14.11)",
  fill: "#C1E5FF"
});

var _ref3 =
/*#__PURE__*/
___EmotionJSX("path", {
  d: "M2.895 23.765c-1.437-5.333 1.72-10.82 7.054-12.258l15.448-4.163 5.204 19.311-15.449 4.164c-5.332 1.437-10.82-1.721-12.257-7.054z",
  fill: "#73C4FF"
});

var _ref4 =
/*#__PURE__*/
___EmotionJSX("ellipse", {
  cx: 51.878,
  cy: 38.114,
  rx: 10.303,
  ry: 9.367,
  transform: "rotate(-12.295 51.878 38.114)",
  fill: "#73C4FF"
});

var SvgComponent = function SvgComponent(props) {
  return ___EmotionJSX("svg", _extends({
    width: 64,
    height: 78,
    fill: "none"
  }, props), _ref, _ref2, _ref3, _ref4);
};

export default __webpack_public_path__ + "static/media/faq-which-thinner.a69c6c14.svg";
export { SvgComponent as ReactComponent };